import React, { Component } from 'react';
import { connect } from 'react-redux';
import BoxInside from '../../../core/BoxInside';
import Withholding from '../../../views/Employee/Withholding';
import Loading from '../../../core/Loading';

import { StyledWrapperWithholding, StyledModalContent } from './style';
import {
  getUserIrpfYears,
  getIrpfByYearLink,
  sendEmailIrpf
} from '../../../../utils/apiWithholding';
import { checkPassword } from '../../../../utils/apiUser';
import { getManagedUsers } from '../../../../utils/apiControlAccess';
import Modal from '../../../core/Modal';

class WithholdingWrapper extends Component {
  constructor(props) {
    super(props);
    const { userId, userName } = props;

    this.state = {
      loading: true,
      years: [],
      selectedYear: null,
      modalPassword: false,
      errorPassword: false,
      errorDni: false,
      employeeSelected: {
        text: userName,
        value: userId
      },
      getCertificate: null,
      isEmailSent: false,
      sendEmail: false,
      modalRRHH: false,
      loadingInModal: false,
      listManagedUsers: []
    };
  }

  componentDidMount() {
    const { roles } = this.props;
    if (roles.includes('ROLE_ACCESS_MANAGER')) {
      getManagedUsers().then(users =>
        this.setState({
          listManagedUsers: users.map(user => ({
            text:
              (user.nombre ? `${user.nombre} ` : '') +
              (user.apellido1 ? `${user.apellido1} ` : '') +
              (user.apellido2 ? `${user.apellido2} ` : ''),
            value: user.idEmpleado
          }))
        })
      );
    }

    getUserIrpfYears()
      .then(result => {
        const listYears = [];
        this.setState({
          loading: false
        });
        result.map((year, index) => {
          const itemYear = {
            value: year,
            text: year,
            id: index
          };
          listYears.push(itemYear);
          return null;
        });
        this.setState({
          years: listYears.reverse(),
          selectedYear: listYears[0].value
        });
      })
      .catch(error => {
        throw error;
      });
  }

  onCheckPassword = (password, nif) => {
    this.setState({
      loadingInModal: true
    });
    checkPassword(password)
      .then(response => {
        this.downloadCertificate(nif, response.token);
      })
      .catch(error => {
        this.setState({
          loadingInModal: false
        });
        if (error.code === 401) {
          this.setState({
            errorPassword: true
          });
        }
      });
  };

  downloadCertificate = (nif, tokenPass) => {
    const { selectedYear, sendEmail, employeeSelected } = this.state;
    this.setState({
      loadingInModal: true
    });
    if (sendEmail) {
      const data = {
        userIdsToSend: [employeeSelected.value],
        year: Math.floor(selectedYear)
      };

      sendEmailIrpf(data)
        .then(() => {
          this.setState({
            isEmailSent: true,
            errorPassword: false,
            errorDni: false,
            modalPassword: false,
            loadingInModal: false
          });
        })
        .catch(() => {
          this.setState({
            errorPassword: true,
            errorDni: false,
            isEmailSent: false,
            loadingInModal: false
          });
        })
        .finally(() =>
          this.setState({
            sendEmail: false,
            errorPassword: false,
            errorDni: false,
            modalPassword: false,
            loadingInModal: false
          })
        );
    } else {
      getIrpfByYearLink(selectedYear, employeeSelected.value, tokenPass, nif)
        .then(response => {
          const extension =
            response.data.type === 'application/pdf' ? 'pdf' : 'zip';
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const fileName = `certificado_${selectedYear}.${extension}`;
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();

          this.setState({
            errorPassword: false,
            errorDni: false,
            modalPassword: false,
            loading: false
          });
        })
        .catch(error => {
          this.setState({
            loadingInModal: false
          });
          if (error.code === 403) {
            this.setState({
              errorPassword: true,
              errorDni: false
            });
          } else if (error.code === 404) {
            this.setState({
              errorPassword: false,
              errorDni: true
            });
          }
        });
    }
  };

  setEmployeeSelected = employee => {
    getUserIrpfYears(employee.value)
      .then(response => {
        const listYears = [];
        this.setState({
          loading: false
        });
        response.map((year, index) => {
          const itemYear = {
            value: year,
            text: year,
            id: index
          };
          listYears.push(itemYear);
          return null;
        });
        if (listYears.length !== 0) {
          this.setState({
            employeeSelected: employee,
            modalPassword: true,
            getCertificate: true,
            years: listYears.reverse(),
            selectedYear: !listYears.length ? '' : listYears[0].value
          });
        } else {
          this.setState({
            getCertificate: false
          });
        }
      })
      .catch(error => {
        throw error;
      });
  };

  render() {
    const {
      loading,
      years,
      selectedYear,
      isEmailSent,
      sendEmail,
      modalPassword,
      getCertificate,
      modalRRHH,
      errorPassword,
      errorDni,
      employeeSelected,
      loadingInModal,
      listManagedUsers
    } = this.state;

    return loading ? (
      <Loading size="xl" />
    ) : (
      <BoxInside>
        <StyledWrapperWithholding>
          <Withholding
            onSelectYear={e => {
              this.setState({
                selectedYear: e.value
              });
            }}
            onClickDownload={() => {
              this.setState({
                modalPassword: true,
                loadingInModal: false,
                errorPassword: false
              });
            }}
            years={years}
            year={selectedYear}
            modalPassword={modalPassword}
            checkPassword={(password, nif) =>
              this.onCheckPassword(password, nif)
            }
            hideModalPassword={() => {
              this.setState({
                modalPassword: false,
                employeeSelected: {}
              });
            }}
            openModalRRHH={() => {
              this.setState({
                modalRRHH: true
              });
            }}
            sendEmail={sendEmail}
            modalRRHH={modalRRHH}
            key={errorPassword}
            errorPassword={errorPassword}
            errorDni={errorDni}
            listManagedUsers={listManagedUsers}
            employeeSelected={employeeSelected}
            loadingInModal={loadingInModal}
            setEmployeeSelected={employee => this.setEmployeeSelected(employee)}
          />

          {getCertificate === false && (
            <Modal
              title="Certificado de Retención"
              clickCloseIcon={() => this.setState({ getCertificate: null })}
            >
              <StyledModalContent>
                El usuario seleccionado no tiene certificados.
              </StyledModalContent>
            </Modal>
          )}
          {isEmailSent && (
            <Modal
              title="Certificado de Retención"
              clickCloseIcon={() => this.setState({ isEmailSent: false })}
            >
              <StyledModalContent>
                El PDF se ha enviado correctamente
              </StyledModalContent>
            </Modal>
          )}
        </StyledWrapperWithholding>
      </BoxInside>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  roles: user.user.roles,
  userId: user.user.userId,
  userName: `${user.user.name} ${user.user.lastname}`
});

export default connect(mapStateToProps)(WithholdingWrapper);
